import { useAuth } from "../../../hooks/useAuth";
import { useState } from "react";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { FormikText } from "../../../components/customFormikComponents/FormikText";
import { Dropdown } from "react-bootstrap";
import { ServeRoute, LANG_COOKIE } from "../../../Constants";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";

const SigninForm = ({ loginState, setLoginState }) => {
  const { startLogin } = useAuth();
  const [CurentLenguaje, setCurentLenguaje] = useState("1");
  const [t, i18n] = useTranslation("global");
  const navigate = useNavigate();

  const VaidateForm = (values) => {
    let error = {
      UserName: "",
      Password: "",
    };
    if (values.UserName === "") {
      error.UserName = "*";
    }
    if (values.Password === "") {
      error.Password = "*";
    }
    if (error.Password === "*" || error.UserName === "*") {
      return error;
    } else {
      return undefined;
    }
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        UserName: "",
        Password: "",
      }}
      validate={(Values) => {
        return VaidateForm(Values);
      }}
      onSubmit={async (values, { resetForm }) => {
        await startLogin(values);
      }}
    >
      {(formik) => (
        <div
          className="
        grid grid-flow-row
        items-center justify-center 
        w-fit px-8 sm:px-0 md:px-16 text-LogLightText 
        rounded-3xl border-[1px]
        text-center mb-4 pt-4 
        bg-black/40 backdrop-blur-[3px]
        transition duration-1000 ease-in-out
        relative
        "
        >
          <h3 className="text-3xl mt-2 mb-1 font-semibold text-white">
            {t("Login.Login")}
          </h3>
          <div className="grid justify-center items-center w-full sm:w-4/6 md:w-full mx-auto gap-y-5 mt-4">
            <Dropdown
              id="ddlLenguaje"
              value={CurentLenguaje}
              drop="left"
              className="bg-skin-secondary active:border-0  hover:text-HeaderHighlight"
            >
              <Dropdown.Toggle variant="" className="text-white w-full">
                {t("Login.CurrentLenguaje")}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  as="button"
                  className="hover:bg-SideBGHover/40 hover:text-SideTextHover"
                  onClick={async () => {
                    i18n.changeLanguage("es");
                    setCurentLenguaje(1);
                  }}
                  data-idculture="1"
                  data-code="es-mx"
                >
                  {t("Login.Esp")}
                </Dropdown.Item>
                <Dropdown.Item
                  as="button"
                  className="hover:bg-SideBGHover/40 hover:text-SideTextHover"
                  onClick={async () => {
                    i18n.changeLanguage("en");
                    setCurentLenguaje(2);
                    const cookies = new Cookies();
                    cookies.remove(LANG_COOKIE, { path: "/" });
                    cookies.set(
                      LANG_COOKIE,
                      t("CurrentLenguaje").toLowerCase(),
                      { path: "/" }
                    );
                  }}
                  data-idculture="2"
                  data-code="en-us"
                >
                  {t("Login.Eng")}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <FormikText
              name="UserName"
              type="text"
              placeholder={t("Login.User")}
              icon="i-user"
            />
            <FormikText
              name="Password"
              type="password"
              placeholder={t("Login.Password")}
              icon="i-lock"
              onKeyDown={(e) => {
                e.code === "Enter" && formik.submitForm();
              }}
            />
            <input
              type="submit"
              className="text-white btn bg-skin-secondary w-[80%]  m-4 rounded-xl hover:bg-skin-secondary/50 "
              value={t("Login.Login")}
              onClick={(e) => {
                formik.handleSubmit();
              }}
            />
          </div>
          <button
            className="mb-4 text-white text-center font-semibold cursor-pointer hover:text-red transition-all ease-in-out duration-300"
            onClick={() => {
              setLoginState(1);
              navigate(`${ServeRoute}/RecoverPassword`);
            }}
          >
            {t("Login.ForgotPassword")}
          </button>
        </div>
      )}
    </Formik>
  );
};

export default SigninForm;
